import { useEffect } from 'react';
import { useReportClientInformation } from '@/hooks/profile/useReportClientInformation';
import { useUpdateLanguage } from '@/hooks/profile/useUpdateLanguage';
import { takePendingLanguageChoice } from '@/utils/language-choice';
import { useMsalAccount } from '@/auth/use-msal-account';
import { logError } from '@/utils/errorReporter';

export const ReportClientInformation = () => {
  const { mutate: reportClientInformation } = useReportClientInformation();
  const { mutate: updateLanguage } = useUpdateLanguage();
  const { isMsalAccountReady } = useMsalAccount();

  useEffect(() => {
    if (isMsalAccountReady) {
      reportClientInformation();

      // a language picked before signing in, sent once now that there is a session (IP-2221)
      const pendingLanguageChoice = takePendingLanguageChoice();

      if (pendingLanguageChoice) {
        updateLanguage(pendingLanguageChoice, {
          // it was cleared before sending, so a failure would otherwise leave no trace
          onError: (error) =>
            logError('pending-language-choice-failed', error, 'report-client-information'),
        });
      }
    }
  }, [isMsalAccountReady]);

  return null;
};
